var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.memberData.id==null)?_c('div',[_c('a',{attrs:{"href":"/login"}},[_c('b-button',{staticClass:"float-button",attrs:{"variant":"primary"}},[_c('i',{staticClass:"fas fa-id-card"}),_vm._v(" Become a Member")])],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }